module.exports = __webpack_public_path__ + "static/media/NABImpact.076327b4.woff";